import { useTranslator } from "@eo-locale/react";

import Cookies from "js-cookie";

import {
  IconButton,
  Button,
  Box,
  FiMessageCircle,
  useBreakpointValue
} from "@/storybook-components";
import { useAppSelector, useAppDispatch } from "@/redux/store/hooks";

import useUnverifiedModal from "@/hooks/useUnverfiedModal";
import useUser from "@/hooks/useUser";
import { setTriggerPoint } from "@/redux/features/unverified-modal/slice";

interface AddCommentButtonProps {
  onClick: () => void;
  isDisabled: boolean;
}

const AddCommentButton = (props: AddCommentButtonProps) => {
  const { onClick, isDisabled } = props;
  const { translate } = useTranslator();
  const dispatch = useAppDispatch();

  const isMobileScreen = useBreakpointValue({
    base: true,
    lg: false
  });

  const { brainstormer, idea } = useAppSelector((state) => state.brainstormers);
  const { triggerPoint } = useAppSelector((state) => state.unverifiedModal);
  const cookieValues = Cookies.get("trigger_point");

  const { allowUnverifiedParticipation } = brainstormer;
  const { isUnverfiedUserLoggedIn, isRegisteredUserLoggedIn } = useUser();
  let cookieTriggerPoint;
  if (cookieValues) {
    cookieTriggerPoint = JSON.parse(cookieValues);
  }
  useUnverifiedModal(allowUnverifiedParticipation, (isProceedAllowed) => {
    if (isProceedAllowed) {
      dispatch(setTriggerPoint({ isTriggeredPointActive: false }));
      if (
        triggerPoint.triggeredSource === "comment" ||
        cookieTriggerPoint?.triggeredSource === "comment"
      ) {
        onClick();
      }

      Cookies.remove("trigger_point");
    }
  });

  const handler = () => {
    if (isDisabled) return;

    if (!isUnverfiedUserLoggedIn && !isRegisteredUserLoggedIn) {
      const triggerPoint = {
        triggeredSource: "comment",
        isTriggeredPointActive: true,
        id: idea?.id
      };
      Cookies.set("trigger_point", JSON.stringify(triggerPoint), {
        expires: 1,
        secure: true,
        sameSite: "Strict"
      });
      dispatch(setTriggerPoint(triggerPoint));
    } else {
      onClick();
    }
  };

  return (
    <Box position="fixed" bottom={5} right={4} zIndex={1}>
      {isMobileScreen ? (
        <IconButton
          aria-label={translate("brainstormers.addComment")}
          icon={<FiMessageCircle />}
          size="lg"
          variant="primary"
          borderRadius="50%"
          boxShadow="lg"
          onClick={handler}
          isDisabled={isDisabled}
        />
      ) : (
        <Button
          aria-label={translate("brainstormers.addComment")}
          variant="primary"
          size={{ base: "lg", lg: "md" }}
          leftIcon={<FiMessageCircle />}
          fontWeight="semibold"
          fontSize="md"
          py={2}
          px={4}
          onClick={handler}
          hidden={isMobileScreen}
          isDisabled={isDisabled}
        >
          {translate("brainstormers.addComment")}
        </Button>
      )}
    </Box>
  );
};

export default AddCommentButton;
